import { type Epic, combineEpics } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import { request } from '@/core';
import { loginRequest } from '@/api/user';
import { navigate } from '@/slices/app';
import { login, setUser } from '../actions';

const loginEpic: Epic = (action$) =>
  action$.pipe(
    filter(login.match),
    request(({ payload }) => loginRequest(payload), login),
  );

const loginSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(login.succeeded.match),
    mergeMap(({ payload: { data: user } }) => [
      setUser(user),
      navigate({ to: '/' }),
    ]),
  );

export default combineEpics(loginEpic, loginSucceededEpic);
